import classNames from 'classnames';
import { autobind } from 'core-decorators';
import { Component } from 'react';
import Title from '/@/components/title';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class TechnologyList extends Component {
    renderTechnology({ id, name, logos, displayInCatalog }) {
        if (!displayInCatalog) return;
        const logo = logos.find((l) => {
            return l.brandId === this.props.brand.id;
        });

        return (
            <div key={id}>
                <div>
                    {logo && <div className={styles.image} style={{ backgroundImage: `url('${logo.image}')` }} />}
                </div>
                <div className={styles.name}>{_(name)}</div>
            </div>
        );
    }
    render() {
        const { technologies, title, size } = this.props;
        const alignText = title === 'Tecnologías' ? 'center' : 'left';
        return (
            <div className={classNames(styles.root, styles[`size-${size}`])}>
                <Title align={alignText} className={styles.title}>
                    {_(title)}
                </Title>
                <div className={styles.technologies}>
                    <div className={styles.container}>
                        <div className={styles.technology}>{technologies.map(this.renderTechnology)}</div>
                    </div>
                </div>
            </div>
        );
    }
}
